import React, {Fragment} from 'react';
import createLink from "../../../../libs/createLink";
// import Icon from "../../../components/Icon";
import {Link} from "react-router-dom";
import _ from 'lodash';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faAngleDoubleRight, faCommentDots, faShare} from '@fortawesome/free-solid-svg-icons'
import {Can} from "../../../../ability-context";
import CtaCannot from "../../../components/CtaCannot";
import ProfileFollows from "./ProfileFollows";
import ProfileAddFriend from "./ProfileAddFriend";
import ShareProfile from "../../../components/ShareProfile";


const ProfileSubNavigation = ({isMe = false, user = {}, currentUser = {}, history = {}}) => {
    return isMe ? (
        <div className="card" id="ProfileSubNavigation">
            <ShareProfile user={user}>
                <div className={"btn-profile-subnav primary shared-profile"}>
                    <FontAwesomeIcon icon={faShare}/>
                    Partager mon profil
                </div>
            </ShareProfile>
        </div>
    ) : (
        <div className="card" id="ProfileSubNavigation">
            {(!_.get(user, 'setting.chatWithOnlyWithFriends') || user.isFriend) && (
                <Can action="create" subject="Room" passThrough>
                    {can => {
                        return can ? (
                            <Link
                                to={{
                                    pathname: createLink("messengerCreate"),
                                    query: {users: [user]}
                                }}
                                className="btn-profile-subnav primary">
                                <FontAwesomeIcon icon={faCommentDots}/> Messenger
                            </Link>
                        ) : (
                            <CtaCannot
                                action={"rooms"}
                                isModal={true}
                                button={
                                    {
                                        isBtn: false,
                                        content: <Fragment><FontAwesomeIcon icon={faCommentDots}/> Messenger</Fragment>,
                                        className: "btn-profile-subnav primary"
                                    }
                                }/>
                        )
                    }}
                </Can>
            )}
            {/*<div className="btn-profile-subnav">
                <FontAwesomeIcon icon={faVideo}/> Appel vidéo
            </div>*/}

            <ProfileAddFriend user={user} history={history}/>
            <Can action="isFollow" subject="User" passThrough>
                {can => {
                    return can ? (
                        !user.isFriend && (
                            <ProfileFollows currentUserId={currentUser._id}
                                            userId={user._id}
                                            isFollow={user.isFollow}
                                            className="btn-profile-subnav"/>
                        )
                    ) : (
                        <CtaCannot
                            action={"addFollow"}
                            isModal={true}
                            button={
                                {
                                    isBtn: false,
                                    content: <Fragment><FontAwesomeIcon icon={faAngleDoubleRight}/> Suivre</Fragment>,
                                    className: "btn-profile-subnav primary-reverse"
                                }
                            }
                        />
                    )
                }}
            </Can>
        </div>
    )
}

export default ProfileSubNavigation;